import Commons from '../../../../Services/Common/Common';

/**
 * SER_BASIC_01 (중대재해처벌법 평가 상세) 스키마
 * - fields: 화면 입력 메타(필수값/라벨/초기값)
 * - mapper: 조회/저장 API payload 매핑 규칙
 */
export const SER_BASIC_01_Schema = {
  fields: {
    sdCode: { initial: '', label: '중대재해처벌법코드' },
    custCd: { initial: '', label: '사업장코드' },
    evaDate: { initial: '', label: '평가일자', required: 'Y' },
    evaName: { initial: '', label: '평가자', required: 'Y' },
    evaPoint: { initial: 0, label: '총 취득 점수' },

    seriousDisaster: { initial: '', label: '착안사항 코드' },
    checkYn: { initial: '0', label: '평가' },

    value: { initial: 0, label: '취득점수' },
    codeNm: { initial: '', label: '항목' },
  },

  mapper: {
    // 마스터 조회
    search1: {
      SdCode: (_, context) => Commons.EncryptAES(context.sdCode),
      UserId: (_, context) => context.userInfo?.userid,
    },

    // 상세 조회
    search2: {
      SdCode: (_, context) => Commons.EncryptAES(context.sdCode),
      UserId: (_, context) => context.userInfo?.userid,
    },

    // 마스터 저장
    save1: {
      UserId: (_, context) => context.userInfo?.userid,
      SdCode: (row) => Commons.EncryptAES(row.sdCode || ''),
      CustCd: (row) => Commons.EncryptAES(row.custCd),
      EvaDate: (row) => Commons.EncryptAES(row.evaDate),
      EvaName: (row) => Commons.EncryptAES(row.evaName),
      EvaPoint: (row) => Commons.EncryptAES(String(row.evaPoint ?? 0)),
    },

    // 상세 저장
    save2: {
      UserId: (_, context) => context.userInfo?.userid,
      SdCode: (row) => Commons.EncryptAES(row.sdCode || ''),
      SeriousDisaster: (row) => Commons.EncryptAES(row.seriousDisaster),
      CheckYn: (row) => Commons.EncryptAES(row.checkYn || '0'),
    },

    // 페이지별 점수 저장
    save3: {
      Value: (row) => Commons.EncryptAES(String(row.value ?? 0)),
      CodeNm: (row) => Commons.EncryptAES(row.codeNm),
      CustCd: (row) => Commons.EncryptAES(row.custCd),
      EvaDate: (row) => Commons.EncryptAES(row.evaDate),
    },
  },
};
